import { isNull, isNumber } from 'lodash';
import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { ILayerProps, IMarkupLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const LabelRotate: React.FC<{
    id: string;
    maxValue?: number;
    minValue?: number;
    onChange?: Function;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onChange, onAfterChange, trackCode, maxValue = 360, minValue = 0 }) => {
    const { $t } = useLocaleStore();
    const oldLayer = useRef<ILayerProps | null>(null);

    const res = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { label } = layer.data as IMarkupLayerProps;
        return {
            rotate: label.rotate,
        };
    });

    if (isNull(res)) return null;

    const { rotate } = res;

    return (
        <div className="c-markup-panel__item c-markup-label">
            <LabelAction title={$t((v) => v.panel.markupPanel.rotate)} align={true}>
                <div style={{ width: 174 }}>
                    <SliderInput
                        value={rotate}
                        max={maxValue}
                        min={minValue}
                        showStepBtn={true}
                        type="horizontal"
                        onChange={(val: number) => {
                            if (id) {
                                if (oldLayer.current === null) {
                                    oldLayer.current = editor.services.flatLayer.getLayer(id, true);
                                    editor.markupLayer.setAttrOperateOriginData(oldLayer.current);
                                }
                                editor.markupLayer.setLabelRotate(id, val);
                            }
                            onChange?.(val);
                        }}
                        onAfterChange={(val: number) => {
                            if (id) {
                                if (oldLayer.current) {
                                    editor.markupLayer.setLabelRotate(id, val, oldLayer.current);
                                }
                                oldLayer.current = null;
                                editor.markupLayer.clearAttrOperateOriginData();
                            }
                            onAfterChange?.(trackCode, val);
                        }}
                    />
                </div>
            </LabelAction>
        </div>
    );
});
